import {
  AddressCardIcon,
  AmazonIcon,
  CartIcon,
  CogsIcon,
  EarthIcon,
  EnvelopeIcon,
  // ExcelIcon,  // was only used by the retired P&L card (#550)
  ExchangeAltIcon,
  HomeIcon,
  PowerOffIcon,
  ProductsIcon,
  UserIcon,
  UserSecretIcon,
  VatIcon,
  WalletIcon
} from '@components';
import { AMAZON_SALES_CHANNEL_ID, SHOPIFY_SALES_CHANNEL_ID } from '@sm/SalesChannels';
import { isFullAccessForFree, isIncompleted, isOnboarding } from '@sm/api';
import { isDemoBuild, isProduction } from '@utils/build';
import ROUTES from './routing';

export const ORDERS_APP = 'Orders';
export const PRODUCTS_APP = 'Products';
export const REFUNDS_APP = 'Refunds';
export const AGENCY_APP = 'Agency';
export const DASHBOARD_APP = 'Dashboard';
export const EMAIL_TOOL_APP = 'Email Follow-Up';
export const INVENTORY_APP = 'Inventory';
export const REPORTS_APP = 'Reports';
export const EXPENSES_APP = 'Expenses';
export const ADVERTISING_APP = 'Marketing';
export const AMAZON_TRAFFIC_APP = 'Amazon Traffic';
export const MONTHLY_BRAND_REVIEW_APP = 'Monthly Brand Review';
export const PNL_APP = 'Profit and Loss';
export const INSIGHTS_APP = 'Insights';
// export const ALERTS_APP = 'Alerts';

const DASHBOARD_APP_ID = 0;
const PRODUCTS_APP_ID = 1;
const ORDERS_APP_ID = 2;
const REFUNDS_APP_ID = 3;
const BA_AGENCY_AP_ID = 4;
const AGENCY_AP_ID = 5;
const EMAIL_TOOL_APP_ID = 6;
const INVENTORY_APP_ID = 7;
const REPORTS_APP_ID = 8;
const EXPENSES_APP_ID = 9;
const ADVERTISING_APP_ID = 10;
const AMAZON_TRAFFIC_APP_ID = 11;
const PNL_APP_ID = 13;
const GO_BACK_TO_AGENCY_ID = 15;
// const ALERTS_APP_ID = 16;

const APP_ID_TO_APP_API_NAME = {
  [DASHBOARD_APP_ID]: 'dashboard',
  //   [ALERTS_APP_ID]: 'alerts',
  [PRODUCTS_APP_ID]: 'products',
  [ORDERS_APP_ID]: 'orders',
  [REFUNDS_APP_ID]: 'refunds',
  [EMAIL_TOOL_APP_ID]: 'email_followup',
  [EXPENSES_APP_ID]: 'expenses',
  [AMAZON_TRAFFIC_APP_ID]: 'amazon_traffic',
  [PNL_APP_ID]: 'profit_and_loss'
};

export const APP_MENU_ITEMS = [
  {
    id: DASHBOARD_APP_ID,
    title: DASHBOARD_APP,
    desc: 'An overview of your business',
    img: HomeIcon,
    link: ROUTES.home
  },
  {
    id: PRODUCTS_APP_ID,
    title: PRODUCTS_APP,
    desc: 'Setup and manage your cogs',
    img: ProductsIcon,
    link: ROUTES.products
  },
  {
    id: ORDERS_APP_ID,
    title: ORDERS_APP,
    desc: 'List, arrange & download your orders',
    img: CartIcon,
    link: ROUTES.orders
  },
  /*
   FIXME: not using now
  { id: 3, title: 'Advertising', desc: 'Get the most out of your Amazon ads', img: AdsIcon },
  */
  {
    id: REFUNDS_APP_ID,
    title: REFUNDS_APP,
    desc: 'All your refunds and product returns',
    img: ExchangeAltIcon,
    link: ROUTES.refunds
  },
  {
    id: BA_AGENCY_AP_ID,
    title: AGENCY_APP,
    desc: 'Your agency dashboard',
    img: UserSecretIcon,
    onClick: history => {
      window.sessionStorage.clear();
      history.push(ROUTES.home);
      history.go();
    }
  },
  {
    id: AGENCY_AP_ID,
    title: AGENCY_APP,
    desc: 'An overview of your business',
    img: UserSecretIcon,
    link: ROUTES.home
  },
  {
    id: EMAIL_TOOL_APP_ID,
    title: EMAIL_TOOL_APP,
    desc: 'Email automation & review requests',
    img: EnvelopeIcon,
    link: ROUTES.email_tool.root
  },
  {
    id: INVENTORY_APP_ID,
    title: INVENTORY_APP,
    desc: 'Inventory description', // FIXME: Replace with correctly data
    img: EnvelopeIcon,
    link: ROUTES.inventory
  },
  // {
  //   id: REPORTS_APP_ID,
  //   title: REPORTS_APP,
  //   desc: 'Analyze key performance indicators',
  //   img: ExcelIcon,
  //   link: ROUTES.reports.root
  // },
  // Expenses page retired (#757)
  // {
  //   id: EXPENSES_APP_ID,
  //   title: EXPENSES_APP,
  //   desc: 'Manage your expenses',
  //   img: WalletIcon,
  //   link: ROUTES.expenses.root
  // },
  {
    id: AMAZON_TRAFFIC_APP_ID,
    title: AMAZON_TRAFFIC_APP,
    desc: 'Find what search terms work for your brand',
    img: AmazonIcon,
    link: ROUTES.amazonTraffic.root
  },
  // Profit and Loss page retired (#550)
  // {
  //   id: PNL_APP_ID,
  //   title: PNL_APP,
  //   desc: 'Analyze key performance indicator',
  //   img: ExcelIcon,
  //   link: ROUTES.pnlDashboard.root
  // },
  //   {
  //     id: ALERTS_APP_ID,
  //     title: ALERTS_APP,
  //     desc: 'Setup alerts for your business',
  //     img: ExclamationIcon,
  //     link: ROUTES.alerts.root
  //   },
  {
    id: ADVERTISING_APP_ID,
    title: ADVERTISING_APP,
    desc: 'Manage your marketing',
    img: EarthIcon,
    link: ROUTES.advertising.root
  },
  {
    id: GO_BACK_TO_AGENCY_ID,
    title: 'Back to Agency View',
    desc: 'An overview of your business',
    img: UserSecretIcon,
    onClick: () => {
      sessionStorage.removeItem('userId');
      sessionStorage.removeItem('hide');
      sessionStorage.removeItem('isOpenedFromAgencyTab');
      if (isDemoBuild()) {
        window.location = ROUTES.demo;
        return;
      }
      window.location.href = `${window.location.protocol}//${window.location.host}/app`;
    }
  }
];

const APP_MENU_MAP = {
  agency: [
    AGENCY_AP_ID
    // ALERTS_APP_ID
  ],
  ba: [
    DASHBOARD_APP_ID,
    PRODUCTS_APP_ID,
    ORDERS_APP_ID,
    REFUNDS_APP_ID,
    BA_AGENCY_AP_ID,
    // EMAIL_TOOL_APP_ID  // Email Follow-Up retired (#532)
    ADVERTISING_APP_ID,
    // EXPENSES_APP_ID  // Expenses page retired (#757)
    AMAZON_TRAFFIC_APP_ID,
    // PNL_APP_ID  // Profit and Loss page retired (#550)
    GO_BACK_TO_AGENCY_ID
    // ALERTS_APP_ID
  ],
  regular: [
    DASHBOARD_APP_ID,
    PRODUCTS_APP_ID,
    ORDERS_APP_ID,
    REFUNDS_APP_ID,
    // EMAIL_TOOL_APP_ID  // Email Follow-Up retired (#532)
    ADVERTISING_APP_ID,
    // EXPENSES_APP_ID  // Expenses page retired (#757)
    AMAZON_TRAFFIC_APP_ID,
    // PNL_APP_ID  // Profit and Loss page retired (#550)
    GO_BACK_TO_AGENCY_ID
    // ALERTS_APP_ID
  ],
  onboarding: []
};

const AVAILABLE_PAGES_BY_SALES_CHANNEL_ID = {
  [AMAZON_SALES_CHANNEL_ID]: [...APP_MENU_MAP.agency, ...APP_MENU_MAP.ba],
  [SHOPIFY_SALES_CHANNEL_ID]: [PRODUCTS_APP_ID, ORDERS_APP_ID] // P&L retired (#550)
};

if (!isProduction()) APP_MENU_MAP.regular.push(REPORTS_APP_ID);

const getAppMenuItems = appIdList => APP_MENU_ITEMS.filter(item => appIdList.includes(item.id));

const getAppMenuIds = profile => {
  if (isIncompleted(profile) || isOnboarding(profile)) return APP_MENU_MAP.onboarding;
  const getApps = () => {
    if (profile.agency) return APP_MENU_MAP.agency;
    if (profile.ba) return APP_MENU_MAP.ba;
    return APP_MENU_MAP.regular;
  };
  let result = getApps();
  if (!profile.amazon_traffic_page) result = result.filter(item => item !== AMAZON_TRAFFIC_APP_ID);
  if (profile.no_marketplaces) {
    result = result.filter(
      item => ![EXPENSES_APP_ID, EMAIL_TOOL_APP_ID, AMAZON_TRAFFIC_APP_ID].includes(item)
    );
  }
  // Profit and Loss page retired (#550)
  // if (profile.pnl_dashboard_start) result.push(PNL_APP_ID);
  const isOpenedFromAgencyTab = sessionStorage.getItem('isOpenedFromAgencyTab') === 'true';
  if (!isOpenedFromAgencyTab) result = result.filter(item => item !== GO_BACK_TO_AGENCY_ID);
  result = result.filter(item =>
    profile.sales_channels.some(channelId =>
      AVAILABLE_PAGES_BY_SALES_CHANNEL_ID[channelId]?.includes(item)
    )
  );
  //   if (isOpenedFromAgencyTab) result = result.filter(item => item !== ALERTS_APP_ID);
  const { apps: profileAppsConfig } = profile;
  if (profileAppsConfig && Object.keys(profileAppsConfig && !profileAppsConfig.all).length) {
    result = result.filter(
      item => profileAppsConfig[APP_ID_TO_APP_API_NAME[item]] || item === GO_BACK_TO_AGENCY_ID
    );
  }
  if (!profile.marketing_page_available) {
    result = result.filter(item => item !== ADVERTISING_APP_ID);
  }
  return result;
};

export const getAvailableMenuItemsUrls = profile => {
  return getAppMenuItems(getAppMenuIds(profile)).map(item => item.link);
};

export const getAppMenu = profile => getAppMenuItems(getAppMenuIds(profile));

const USER_MENU_ITEMS = [
  {
    id: 0,
    title: 'Profile',
    desc: 'Manage your account preferences',
    img: UserIcon,
    link: ROUTES.profile.general,
    always_available: true
  },
  {
    id: 1,
    title: 'Seller Accounts',
    desc: 'Connect more Seller Central accounts',
    img: CogsIcon,
    link: ROUTES.accounts,
    api_name: 'accounts'
  },
  {
    id: 2,
    title: 'Plans & Billing',
    desc: 'Manage your bills & payment option',
    img: WalletIcon,
    link: ROUTES.plans,
    api_name: 'plans'
  },
  {
    id: 3,
    title: 'Plans & Billing',
    desc: 'Manage your bills & payment option',
    img: WalletIcon,
    link: ROUTES.billing,
    api_name: 'billing'
  },
  {
    id: 4,
    title: 'Clients',
    desc: 'Manage and invite new clients',
    link: ROUTES.users,
    img: AddressCardIcon,
    api_name: 'clients'
  },
  {
    id: 5,
    title: 'VAT',
    desc: 'Configure your VAT settings',
    img: VatIcon,
    link: ROUTES.vat,
    api_name: 'vat'
  },
  {
    id: 6,
    title: 'Log Out',
    desc: 'Stay safe, we’ll see you next time',
    img: PowerOffIcon,
    logout: true,
    always_available: true
  }
];

const USER_MENU_LINK_TO_MENU_ITEM_MAP = USER_MENU_ITEMS.reduce(
  (acc, item) => ({ ...acc, [item?.link?.replace('/', '')]: item }),
  {}
);

const USER_MENU_MAP = {
  agency: [ROUTES.profile.general, ROUTES.users],
  regular: [ROUTES.profile.general, ROUTES.accounts],
  plansBilling: [ROUTES.plans, ROUTES.billing],
  onboarding: []
};

const getUserMenuItems = linkList =>
  USER_MENU_ITEMS.filter(item => item.logout || linkList.includes(item.link));

export const getUserMenuLinks = profile => {
  if (isIncompleted(profile) || isOnboarding(profile)) return USER_MENU_MAP.onboarding;
  let result = [...(profile.agency ? USER_MENU_MAP.agency : USER_MENU_MAP.regular)];
  if (profile.billing && !isFullAccessForFree(profile)) {
    result.push(profile?.subscription?.cc ? ROUTES.billing : ROUTES.plans);
  }
  if (profile.useVAT && !profile.agency) result.push(ROUTES.vat);

  const { apps: profileAppsConfig } = profile;
  if (profileAppsConfig && Object.keys(profileAppsConfig).length && !profileAppsConfig.all) {
    result = result.filter(menuUrl => {
      const menuItem = USER_MENU_LINK_TO_MENU_ITEM_MAP[menuUrl.replace('/', '')];
      return profileAppsConfig[menuItem?.api_name] || menuItem?.always_available;
    });
  }
  return result;
};

export const getAvailableUserMenuUrls = profile => {
  const links = getUserMenuLinks(profile);
  if (links.includes(ROUTES.billing)) links.push(ROUTES.plans);
  return links;
};

export const getUserMenu = profile => getUserMenuItems(getUserMenuLinks(profile));
